import { Component, Input } from '@angular/core';
import { HelpService } from 'src/app/core/services/help.service';

const SECTION_LABELS: Record<string, string> = {
  'configurations':    'Configurations',
  'device-management': 'Device Management',
  'account-users':     'Account & Users',
  'integrations':      'Integrations',
  'content-placement': 'Content Placement',
  'branding':          'Branding',
  'licenses':          'License Manager',
  'automated-actions': 'Automated Actions',
  'tvnow':             'TVNow Web Player',
  'getting-started':   'Getting Started',
  'audit-logs':        'Audit Logs',
  'tag-manager':       'Tag Manager',
  'content-library':   'Content Library',
  'display-activation': 'Display Activation',
};

@Component({
  selector: 'app-help-button',
  templateUrl: './help-button.component.html',
  styleUrls: ['./help-button.component.scss'],
  standalone: false,
})
export class HelpButtonComponent {
  @Input() inline = false;

  constructor(private helpService: HelpService) {}

  get drawerOpen(): boolean {
    return this.helpService.drawerOpen;
  }

  get tooltip(): string {
    const { section } = this.helpService.getContext();
    const label = SECTION_LABELS[section];
    return label ? `Help: ${label}` : 'Open User Guide';
  }

  openHelp(): void {
    this.helpService.openHelp();
  }
}
